import script from "./choosepayment.vue?vue&type=script&setup=true&lang=js"
export * from "./choosepayment.vue?vue&type=script&setup=true&lang=js"

import "./choosepayment.vue?vue&type=style&index=0&id=9af16f08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9af16f08"]])

export default __exports__